module.exports = __webpack_public_path__ + "static/chisel-c285a80ada7ee0c885b9fbe5ea8fb3b9.svg";